// extracted by mini-css-extract-plugin
module.exports = {"faqs":"faq_faqs__3YRWM","container":"faq_container__35PF7","sectitel":"faq_sectitel__1Nu49"};